import { SxProps, Theme } from '@mui/material';
import { commonInputStyle } from '../../../../components/CustomFormsComponents/CustomField';

export const srtStyles = {
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        p: 2,
        pb: 12
    },
    headerCard: {
        p: 2,
        borderRadius: 2,
        bgcolor: '#fff',
        boxShadow: '-1px 1px 4px rgba(0, 0, 0, 0.10)',
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        flexDirection: { xs: 'column', sm: 'row' }
    },
    headerContent: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
    },
    headerIcon: {
        width: 40,
        height: 40,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F3F8F8',
        color: 'var(--primary)'
    },
    headerTitle: {
        color: '#384A52',
        fontWeight: 700,
        fontSize: 20,
        lineHeight: 1.2
    },
    headerSubtitle: {
        color: '#476773',
        fontSize: 14
    },
    exportActions: {
        display: 'flex',
        gap: 1,
        flexWrap: 'wrap'
    },
    exportButton: {
        minWidth: 150,
        height: 36,
        textTransform: 'uppercase'
    },
    investigationHeader: {
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        flexDirection: { xs: 'column', sm: 'row' },
        marginTop: 5
    },
    investigationTitle: {
        color: '#384A52',
        fontSize: 24,
        fontWeight: 700
    },
    collapseAllButton: {
        minWidth: 150,
        height: 36
    },
    sectionCard: {
        borderRadius: 2,
        bgcolor: '#fff',
        boxShadow: '-1px 1px 4px rgba(0, 0, 0, 0.10)',
        overflow: 'hidden'
    },
    sectionHeader: (isOpen: boolean): SxProps<Theme> => ({
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        cursor: 'pointer',
        borderBottom: isOpen ? '1px solid rgba(0, 0, 0, 0.12)' : 'none'
    }),
    sectionTitleWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
    },
    sectionNumber: {
        minWidth: 30,
        height: 24,
        px: 1,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F3F8F8',
        color: '#476773',
        fontSize: 12,
        fontWeight: 700
    },
    sectionTitle: {
        color: '#384A52',
        fontSize: 18,
        fontWeight: 700
    },
    sectionActions: {
        display: 'flex',
        alignItems: 'center',
        gap: 1
    },
    statusChip: (isComplete: boolean): SxProps<Theme> => ({
        borderRadius: 1,
        fontWeight: 700,
        color: isComplete ? '#1C6B2A' : '#C25B16',
        backgroundColor: isComplete ? '#EAF7ED' : '#FFF7ED',
        border: `1px solid ${isComplete ? '#CBE8D2' : '#FED7AA'}`
    }),
    sectionBody: {
        p: 3,
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(12, 1fr)' },
        gap: 2
    },
    fieldGridColumn: (columns?: number): SxProps<Theme> => ({
        gridColumn: {
            xs: 'span 12',
            md: `span ${columns || 4}`
        }
    }),
    textField: {
        ...commonInputStyle,
        '& .MuiOutlinedInput-root': {
            borderRadius: '10px'
        },
        '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
            top: '44%',
            left: 0,
            transform: 'translate(14px, -14px) scale(1)'
        },
        '& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled, & .MuiInputLabel-root.MuiInputLabel-shrink':
            {
                top: 0,
                left: 0,
                transform: 'translate(14px, -9px) scale(0.75)'
            }
    },
    radioControl: {
        width: '100%',
        minHeight: 64,
        pt: 1
    },
    radioLabel: {
        color: '#476773',
        fontSize: '1rem',
        fontWeight: 400
    },
    repeatableWrapper: {
        gridColumn: 'span 12',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5
    },
    repeatableRow: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(12, 1fr) 32px' },
        gap: 2,
        p: 2,
        borderRadius: 2,
        bgcolor: '#fff',
        boxShadow: '-1px 1px 4px rgba(0, 0, 0, 0.10)'
    },
    deleteButton: {
        alignSelf: 'center',
        color: '#476773'
    },
    nestedRepeatableWrapper: {
        gridColumn: 'span 12',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        pl: { xs: 0, md: 3 }
    },
    nestedRepeatableRow: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(12, 1fr) 32px' },
        alignItems: 'center',
        gap: 2,
        p: 1.5,
        borderRadius: 2,
        bgcolor: '#F8FAFC',
        border: '1px solid #E2E8F0'
    },
    nestedDeleteButton: {
        alignSelf: 'center',
        color: '#476773'
    },
    addButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    nestedAddButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    addButton: {
        minWidth: 150,
        height: 36
    },
    internalDivider: {
        gridColumn: 'span 12',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        pt: 2,
        mt: 1
    },
    internalDividerTitle: {
        color: '#384A52',
        fontSize: 16,
        fontWeight: 700,
        textTransform: 'uppercase',
        padding: '10px'
    },
    highlightedFieldCard: {
        gridColumn: 'span 12',
        p: 2,
        borderRadius: 2,
        backgroundColor: '#FFFBEB',
        border: '1px solid #FDE68A',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(12, 1fr)' },
        gap: 2
    },
    highlightedFieldCardTitle: {
        gridColumn: 'span 12',
        color: '#92400E',
        fontSize: 16,
        fontWeight: 700
    },
    footerBar: {
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (theme: Theme) => theme.zIndex.drawer - 1,
        px: 3,
        py: 1.5,
        bgcolor: '#fff',
        boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.12)'
    },
    footerActions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 2,
        flexWrap: 'wrap',
        pr: { xs: 2, md: '100px' }
    },
    footerButton: {
        minWidth: 170,
        height: 38
    },
    scrollTopButton: {
        width: 38,
        height: 38,
        border: '1px solid var(--primary)',
        color: 'var(--primary)',
        borderRadius: '5px'
    }
} satisfies Record<string, SxProps<Theme> | ((...args: any[]) => SxProps<Theme>)>;
